import { FC, Fragment } from "react";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";

import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

type option = { id: number; color: string };

export type SelectColorprops = {
  selected: option;
  setSelected: (option: option) => void;
  options: option[];
  tittle: string;
  textDescribe?: string;
  span?: string;
  error?: boolean;
  textError?: string;
};

export const SelectColor: FC<SelectColorprops> = ({
  selected,
  setSelected,
  options,
  tittle,
  textDescribe,
  span,
  error,
  textError,
}) => {
  return (
    <Fragment>
      <Listbox value={selected} onChange={setSelected}>
        <div className="flex justify-between">
          <Label className="block text-sm font-medium leading-6 text-gray-900">
            {tittle}
          </Label>
          <span className={`text-sm leading-6 text-gray-500`}>{span}</span>
        </div>

        <div className="relative">
          <ListboxButton
            className={`relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6 ${
              error === true
                ? "ring-red-300 placeholder:text-red-300"
                : "ring-gray-300 placeholder:text-gray-400"
            } focus:ring-2 focus:ring-inset ${
              error === true ? "focus:ring-red-500" : "focus:ring-primary"
            } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6`}

            //className=""
          >
            <span
              className="block truncate"
              style={{ backgroundColor: selected?.color }}
            >
              &nbsp;
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                aria-hidden="true"
                className="h-5 w-5 text-gray-400"
              />
            </span>
          </ListboxButton>
          <ListboxOptions
            transition
            className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
          >
            {options.map((option) => (
              <ListboxOption
                key={option.id}
                value={option}
                className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-primary-600 data-[focus]:text-white"
              >
                <div
                  className="mr-2 block truncate font-normal group-data-[selected]:font-semibold"
                  style={{ backgroundColor: option.color }}
                >
                  &nbsp;
                </div>

                <span className="pl-6 absolute inset-y-0 right-0 flex items-center pr-4 text-primary-600 group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="h-5 w-5"
                    aria-hidden="true"
                  />
                </span>
              </ListboxOption>
            ))}
          </ListboxOptions>

          {error === true ? (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>
          ) : (
            <></>
          )}
        </div>

        {error === true ? (
          <>
            <p className={`mt-1 text-sm text-red-600`}>{textError}</p>
          </>
        ) : (
          <></>
        )}

        {/* Descripción en gris */}
        <p className="mt-1 text-sm text-gray-400">{textDescribe}</p>
      </Listbox>
    </Fragment>
  );
};
